import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { pageTitle } from '../PageTitle';
import BreadCrumb from '../BreadCrumb';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';
import team1 from "../../assets/images/resource/team-01.png";
import team2 from "../../assets/images/resource/team-02.png";
import team3 from "../../assets/images/resource/team-03.png";
import team4 from "../../assets/images/resource/team-04.png";
import team5 from "../../assets/images/resource/team-05.png";
import team6 from "../../assets/images/resource/team-06.png";
import team7 from "../../assets/images/resource/team-07.png";
import team8 from "../../assets/images/resource/team-08.png";

const Team = () => {
  pageTitle('Team');

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const teamData = [
    { id: 1, name: 'Annette Black', image: team1, delay: '00ms' },
    { id: 2, name: 'Kristin Watson', image: team2, delay: '100ms' },
    { id: 3, name: 'Devon Lane', image: team3, delay: '200ms' },
    { id: 4, name: 'Kristin Watson', image: team4, delay: '300ms' },
    { id: 5, name: 'Puspa Vaw', image: team5, delay: '00ms' },
    { id: 6, name: 'Tomy Debs', image: team6, delay: '100ms' },
    { id: 7, name: 'Dev Kow Tson', image: team7, delay: '200ms' },
    { id: 8, name: 'Jon Watson', image: team8, delay: '300ms' },
  ];

  return (
    <>
      <HeaderOne />
      <BreadCrumb />
      <div className="team__page p_relative see__pad">
        <div className="auto-container">
          <div className="row">
            {teamData.map((item) => (
              <div
                className="col-lg-3 col-md-6 col-sm-12"
                key={item.id}
                data-aos="fade-up"
                data-aos-delay={item.delay}
              >
                <div className="team__block">
                  <div className="team__img">
                    <figure>
                      <img src={item.image} alt={item.name} />
                    </figure>
                  </div>
                  <div className="team__name">
                    <h3>{item.name}</h3>
                  </div>
                  <div className="team__media">
                    <ul>
                      <li><Link to="#">FB.</Link></li>
                      <li><Link to="#">TW.</Link></li>
                      <li><Link to="#">LI</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <FooterOne />
    </>
  );
};

export default Team;
